export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_quantlabs.png",
      alt: "Nome da extensão",
    },
    title: "Menos emoção, mais razão. Think Quant.",
    text: [
      "A Quant Labs desenvolve estratégias quantitativas automatizadas para investidores que buscam operar o mercado com mais disciplina, lógica e objetividade. Minimizamos a interferência emocional da execução das operações por meio de arquiteturas automatizadas desenvolvidas com pesquisa, modelagem estatística e validação contínua.",
    ],
    testimonial: {
      text: "Think Quant é trocar o impulso pela razão. O ser humano não aguenta a pressão do mercado. A arquitetura da Quant Labs sim.",
      author: {
        name: "Rafael Faria, fundador da Quant Labs",
        // "picture": "https://i.pravatar.cc/150?img=70"
      },
    },
  },
  stats: {
    title: "O padrão Quant Labs",
    subtitle: "Desenvolvemos algoritmos que unem pesquisa, tecnologia e consistência estatística.",
    data: [
      {
        value: "100%",
        description: "Execução Automatizada",
      },
      {
        value: "0%",
        description: "Interferência Emocional",
      },
      {
        value: "100%",
        description: "Controle de Capacity",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Quant Labs?",
    subtitle: "Veja quais as principais vantagens dos robôs da Quant Labs.",
    data: [
      {
        title: "Liberdade",
        description: "Participe do mercado sem precisar acompanhar gráficos o dia inteiro.",
      },
      {
        title: "Velocidade",
        description: "Nossos algoritmos reagem em milissegundos, superando qualquer reação humana.",
      },
      {
        title: "Objetividade",
        description: "Cada decisão é baseada em regras quantitativas, jamais em emoções ou intuição.",
      },
      {
        title: "Evolução",
        description:
          "Monitoramos e aprimoramos continuamente nossas estratégias para acompanhar a evolução dos mercados.",
      },
      {
        title: "Validação",
        description:
          "Cada estratégia passa por um rigoroso processo de pesquisa, testes e validação antes da execução.",
      },
      {
        title: "Suporte",
        description:
          "Oferecemos atendimento técnico direto e especializado para garantir o funcionamento das suas estratégias.",
      },
    ],
  },
  cta: {
    title: "Deixe a emoção fora das suas operações.",
    subtitle: "Opere com a tecnologia da Quant Labs agora.",
    buttonText: "Acessar laboratório",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "O Laboratório",
    col1: [
      "A Quant Labs nasceu da convicção de que decisões financeiras não deveriam depender de impulso, ansiedade ou interpretação emocional do mercado.",
      "Em nosso laboratório, transformamos pesquisa quantitativa, modelagem estatística e automação em arquiteturas desenvolvidas para executar estratégias com disciplina, lógica e objetividade.",
      "Cada algoritmo passa por um processo contínuo de pesquisa, validação e monitoramento, buscando consistência operacional diante da complexidade e do estresse natural dos mercados. ",
    ],
    col2: [
      "Idealizada por Rafael Faria, profissional certificado pelo mercado financeiro, a Quant Labs foi construída para aproximar o investidor comum de uma abordagem mais racional, tecnológica e sistemática de participação no mercado.",
      "Não desenvolvemos estratégias baseadas em promessas ou tendências passageiras. Desenvolvemos tecnologia orientada por dados, regras quantitativas e execução disciplinada.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Quant Labs",
  },
  strategies: {
    title: "Estratégias Quant Labs ",
    heading: "A inteligência do nosso laboratório operando por você.",
    subtitle:
      "Conecte-se à tecnologia da Quant Labs e opere o mercado com uma execução mais disciplinada, objetiva e eficiente. Nossos algoritmos foram desenvolvidos para reduzir a interferência emocional das operações e executar estratégias quantitativas com lógica, consistência e precisão.",
  },
  testimonials: [
    {
      text: "O mercado financeiro exige decisões sob pressão constante, onde emoções como medo, ansiedade e euforia tendem a influenciar nosso julgamento. Ao automatizar a execução das operações, a tecnologia da Quant Labs reduz a influência desses vieses emocionais, favorecendo decisões mais consistentes e uma relação mais saudável com o mercado.",
      author: "Ana Carolina Stoppa",
      job: "Psicóloga",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Quant Labs muito bem representada pelo Rafael. Um excelente profissional! Tive a oportunidade de acompanhar alguns de seus trabalhos e fiquei impressionado com sua dedicação, comprometimento e atenção aos detalhes. Recomendo com confiança.",
      author: "Gabriel Camargos",
      job: "Engenheiro Civil",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
